<template>
	<div class="mainBox" style="padding-bottom: 0.1rem;">
		<div class="topNav">
			<van-nav-bar safe-area-inset-top :placeholder="true" :fixed="true" title="新增报验记录" left-text="返回" left-arrow
				@click-left="goBack">
			</van-nav-bar>
		</div>
		<van-form @submit="onSubmit">
			<van-cell-group>
				<van-field readonly clickable :value="subjectMatter" name="subjectMatter" label="标的物" placeholder="请选择标的物"
					:rules="[{ required: true, message: '' }]" @click="showSubjectMatterPicker = true" />
				<van-popup v-model="showSubjectMatterPicker" position="bottom">
					<van-picker show-toolbar :columns="subjectMatterList" value-key="displayName"
						@confirm="selSubjectMatter" @cancel="showSubjectMatterPicker = false" />
				</van-popup>
				<van-field readonly clickable :value="major" name="major" label="专业" placeholder="请选择专业"
					:rules="[{ required: true, message: '' }]" @click="showMajorPicker = true" />
				<van-popup v-model="showMajorPicker" position="bottom">
					<van-picker show-toolbar :columns="majorList" value-key="displayName" @confirm="selMajorPicker"
						@cancel="showMajorPicker = false" />
				</van-popup>
				<van-field v-model="recSortCode" name="recSortCode" label="序号" placeholder="请输入序号" />
				<!-- <van-field readonly clickable
					:value="category"
					name="category" 
					label="范畴" 
					placeholder="请选择范畴"
					:rules="[{ required: true, message: '' }]"
					@click="showCategoryPicker = true" />
				<van-popup v-model="showCategoryPicker" position="bottom">
					<van-picker show-toolbar :columns="categoryList" value-key="name" @confirm="selCategoryPicker" @cancel="showCategoryPicker = false" />
				</van-popup> -->
				<!-- <van-field readonly clickable
					:value="checkType"
					name="checkType" 
					label="检验形式" 
					placeholder="请选择检验形式"
					:rules="[{ required: true, message: '' }]"
					@click="showCheckTypePicker = true" />
				<van-popup v-model="showCheckTypePicker" position="bottom">
					<van-picker show-toolbar :columns="checkTypeList" value-key="displayName" @confirm="selCheckTypePicker" @cancel="showCheckTypePicker = false" />
				</van-popup>
				<van-field
					v-model="parts"
					name="parts"
					label="部件"
					placeholder="请输入部件"
				/> -->
				<van-field readonly clickable :value="date" name="date" label="检验时间" placeholder="请选择检验时间"
					:rules="[{ required: true, message: '' }]" @click="showDateCalendar = true" />
				<van-calendar v-model="showDateCalendar" :min-date="minDate" :max-date="maxDate" color="#1989fa"
					@confirm="selDateCalendar" />
				<van-field class="textareaField" v-model="content" type="textarea" name="content" label="检验项目"
					placeholder="请输入检验项目" :rules="[{ required: true, message: '' }]" />
				<van-field v-model="userName" name="userName" label="检验人" placeholder="请输入检验人"
					:rules="[{ required: true, message: '' }]" />
				<van-field readonly clickable :value="conclusion" name="conclusion" label="1次检验结论" placeholder="请选择1次检验结论"
					:rules="[{ required: true, message: '' }]" @click="showConclusionPicker = true" />
				<van-popup v-model="showConclusionPicker" position="bottom">
					<van-picker show-toolbar :columns="conclusionList" value-key="displayName"
						@confirm="selConclusionPicker" @cancel="showConclusionPicker = false" />
				</van-popup>
				<van-field readonly clickable :value="conclusion2" name="conclusion2" label="2次检验结论"
					placeholder="请选择2次检验结论" />
				<van-field readonly clickable :value="conclusion3" name="conclusion3" label="2次以上结论"
					placeholder="请选择2次以上检验结论" />
				<van-field class="textareaField" v-model="sutContent" type="textarea" name="sutContent" label="检验意见"
					placeholder="请输入检验意见" :rules="[{ required: true, message: '' }]" />
				<van-field class="textareaField" v-model="remark" type="textarea" name="remark" label="备注"
					placeholder="请输入备注" />
				<van-field v-model="closeMan" name="closeMan" label="封闭人" placeholder="请输入封闭人" />
				<van-field readonly clickable :value="closeTime" name="closeTime" label="封闭时间" placeholder="请选择封闭时间"
					@click="showCloseTimeCalendar = true" />
				<van-calendar v-model="showCloseTimeCalendar" :min-date="minDate" :max-date="maxDate" color="#1989fa"
					@confirm="selCloseTimeCalendar" />
				<van-cell-group style="margin-top: 13px;">
					<van-field class="uploaderField" name="scenePhotoList" label="整改前照片">
						<template #input>
							<van-uploader v-model="scenePhotoList" :after-read="uploadBeforePhoto"
								:before-delete="beforePhotoDelete" accept="image/*" />
						</template>
					</van-field>
				</van-cell-group>
				<van-cell-group style="margin-top: 13px;">
					<van-field class="uploaderField" name="closePhotoList" label="整改后照片">
						<template #input>
							<van-uploader v-model="closePhotoList" :after-read="uploadClosePhoto"
								:before-delete="closePhotoDelete" accept="image/*" />
						</template>
					</van-field>
				</van-cell-group>
			</van-cell-group>
			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit">保存</van-button>
			</div>
		</van-form>
	</div>
</template>
<script>
import { saveTestRecord, getNextRecCode } from '../../api/safeInspection'
import { upload, getInspectionConclusion, getProblemImportant, getMajorList, getTestItemTestType, getSubjectDropDown } from '../../api/commonApi'
import { getNowDate } from "../../utils/date"
import { Notify } from 'vant';
import ImageCompressor from '@/utils/ImageCompressor'
import common from '../../utils/common';

export default {
	name: 'safeInspectionAdd',
	data() {
		return {
			subjectMatter: "",
			subjectMatterId: "",
			showSubjectMatterPicker: false,
			// 模拟数据
			subjectMatterList: [
			],
			major: "",
			majorId: "",
			recSortCode: "",
			showMajorPicker: false,
			showCloseTimeCalendar: false,
			// 模拟数据
			majorList: [
			],
			category: "",
			categoryId: "",
			showCategoryPicker: false,
			categoryList: [
				{ id: 1, name: "质量" }
			],
			checkType: "",
			checkTypeId: "",
			showCheckTypePicker: false,
			checkTypeList: [
			],
			parts: "",
			date: "",
			showDateCalendar: false,
			content: "",
			// 画面中的项目：检验意见
			sutContent: "",
			// 备注
			remark: "",
			conclusion: "",
			conclusion2: "",
			conclusionId2: "",
			conclusion3: "",
			conclusionId3: "",
			showConclusionPicker: false,
			showConclusion2Picker: false,
			showConclusion3Picker: false,
			codeFlg: "",
			// 模拟数据
			conclusionList: [
			],
			important: "",
			importantId: "",
			showImportantPicker: false,
			// 模拟数据
			importantList: [
			],
			// 检验人
			userName: "",
			applyDate: "",
			applyMan: "",
			fileList: [],
			minDate: new Date(new Date().getFullYear() - 2, 0, 1, 0, 0, 0),
			maxDate: new Date(new Date().getFullYear() + 2, 11, 31, 23, 59, 59),
			project: {},
			user: {},
			addPhotoList: [],
			addScenePhotoList: [],
			scenePhotoList: [],
			addCloseFileList: [],
			closeFileList: [],
			addClosePhotoList: [],
			closePhotoList: [],
			closeTime: "",
			closeMan: "",
			businessType: "10", // 业务类型: 01:报验记录照片 10:问题照片 11:问题及意见文件 20:收文、发文、周报、月报等文件信息 93:协调记录照片 94:质量进度照片 95:周月报照片临时文件 96:完工资料 97:合同扫描件 98:加班审核 99:请假审核"
			fileKey: "0", // 业务类型=(01、10、11、96、97、98、99)时，默认值0，业务类型=20时，需要传入文件类型下拉选择列表对应的VALUE")
		}
	},
	mounted() {
		this.project = common.getProject();
		if (this.project == null || this.project == undefined || !this.project.workNo) {
			Notify({ type: 'danger', message: '获取工作控制号失败' });
		}
		this.applyDate = getNowDate()
		this.date = getNowDate()

		this.user = common.getUser();
		this.userName = this.user.username
		this.doGetTestItemTestType()
		this.doGetInspectionConclusion()
		this.doGetProblemImportant()
		this.doGetSubjectDropDown()
		this.doGetMajorList()
	},
	methods: {
		// 根据标的物查询专业
		doGetMajorList() {
			getMajorList(this.project.workNo).then(response => {
				this.majorList = response.data.body
			})
		},
		// 检验形式
		doGetTestItemTestType() {
			getTestItemTestType().then(response => {
				this.checkTypeList = response.data.body
			})
		},
		// 检验结论
		doGetInspectionConclusion() {
			getInspectionConclusion().then(response => {
				this.conclusionList = response.data.body
			})
		},
		handleChange() {
			console.log("start ")
			if (this.subjectMatterId && this.major) {
				this.doGetNextRecCode();
			}
		},
		doGetNextRecCode() {
			const param = {
				workNo: this.project.workNo,
				subjectNo: this.subjectMatterId,
				major: this.majorId,
				// 范畴。质量：1 ； 安全：2； 进度：3
				category: 2,
			}
			getNextRecCode(param).then(response => {
				this.recSortCode = response.data.body
				if (this.recSortCode === '') {
					this.recSortCode = '1'
				}
			})
		},
		// 重要程度
		doGetProblemImportant() {
			getProblemImportant().then(response => {
				this.importantList = response.data.body
			})
		},
		// 标的物
		doGetSubjectDropDown() {
			getSubjectDropDown(this.project.workNo).then(response => {
				this.subjectMatterList = response.data.body
			})
		},
		goBack() {
			this.$router.push({
				name: 'safeInspectionList'
			});
		},
		selSubjectMatter(data) {
			this.subjectMatter = data.displayName;
			this.showSubjectMatterPicker = false;
			if (this.subjectMatterId != data.displayValue) {
				this.subjectMatterId = data.displayValue
				// clear major value
				this.major = ""
				this.majorId = ""
			}
			this.handleChange()
		},
		selMajorPicker(data) {
			this.major = data.displayName;
			this.majorId = data.displayValue;
			this.showMajorPicker = false;
			this.handleChange()
		},
		selCategoryPicker(data) {
			this.category = data.name;
			this.categoryId = data.id;
			this.showCategoryPicker = false;
		},
		selCheckTypePicker(data) {
			this.checkType = data.displayName;
			this.checkTypeId = data.displayValue;
			this.showCheckTypePicker = false;
		},
		selConclusionPicker(data) {
			this.conclusion = data.displayName;
			this.conclusionId = data.displayValue;
			this.showConclusionPicker = false;
			if (this.conclusionId == '0') {
				// clear import value
				this.important = '';
				this.importantId = '';
			}
		},
		selDateCalendar(date) {
			this.date = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
			this.showDateCalendar = false;
		},
		selCloseTimeCalendar(date) {
			this.closeTime = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
			this.showCloseTimeCalendar = false;
		},
		selImportantPicker(data) {
			this.important = data.displayName;
			this.importantId = data.displayValue;
			this.showImportantPicker = false;
		},
		async uploadFile(file) {
			// 此时可以自行将文件上传至服务器
			const files = file.file;
			let newFile = await ImageCompressor(files); //图片压缩
			const formData = new FormData();
			formData.append('file', newFile);
			const url = this.project.workNo + "/" + this.businessType + "/" + this.fileKey;
			upload(url, formData).then(response => {
				if (response.data.resultCode === 200) {
					const dataBody = response.data.body
					this.addCloseFileList.push(
						{
							recFileType: '2',
							fileName: this.extractFileName(dataBody.fileName),
							filePath: dataBody.fileSavePath,
							photoPathUri: dataBody.fileUri
						}
					)
				}
			})
		},
		extractFileName(fileName) {
			let index = fileName.lastIndexOf(".");
			return fileName.substr(0, index)
		},
		async uploadClosePhoto(file) {
			// 此时可以自行将文件上传至服务器
			const files = file.file;
			let newFile = await ImageCompressor(files); //图片压缩
			const formData = new FormData();

			formData.append('file', newFile);
			const url = this.project.workNo + "/" + this.businessType + "/" + this.fileKey;
			upload(url, formData).then(response => {
				if (response.data.resultCode === 200) {
					const dataBody = response.data.body
					this.addClosePhotoList.push(
						{
							recFileType: '1',
							fileName: dataBody.fileName,
							filePath: dataBody.fileSavePath,
							photoPathUri: dataBody.fileUri
						}
					)
				}
			})
		},
		async uploadBeforePhoto(file) {
			console.log(file)
			// 此时可以自行将文件上传至服务器
			const files = file.file;
			console.log(files)
			let newFile = await ImageCompressor(files); //图片压缩
			const formData = new FormData();

			formData.append('file', newFile);
			const url = this.project.workNo + "/" + this.businessType + "/" + this.fileKey;
			upload(url, formData).then(response => {
				if (response.data.resultCode === 200) {
					const dataBody = response.data.body
					this.addScenePhotoList.push(
						{
							recFileType: '0',
							fileName: dataBody.fileName,
							filePath: dataBody.fileSavePath,
							photoPathUri: dataBody.fileUri
						}
					)
					console.log(this.addScenePhotoList)
				}
			})
		},
		beforeDelete(file, detail) {
			this.fileList.splice(detail.index, 1)
			// 删除照片
			this.addPhotoList.splice(detail.index, 1)
		},
		beforePhotoDelete(file, detail) {
			this.scenePhotoList.splice(detail.index, 1)
			// 删除照片
			this.addScenePhotoList.splice(detail.index, 1)
		},
		closePhotoDelete(file, detail) {
			this.closePhotoList.splice(detail.index, 1)
			// 删除照片
			this.addClosePhotoList.splice(detail.index, 1)
		},
		closeFileDelete(file, detail) {
			this.closeFileList.splice(detail.index, 1)
			// 删除照片
			this.addCloseFileList.splice(detail.index, 1)
		},
		onSubmit(data) {
			if (!common.hasPermision("information:add:2")) {
				Notify({ type: 'danger', message: "无操作权限" });
				return;
			}
			const param = {
				t: new Date().getTime(),
				workNo: this.project.workNo,
				name: "0",// 后端没有对应字段
				subjectNo: this.subjectMatterId,
				desc: "",// 后端没有对应字段
				major: this.majorId,
				recSortCode: this.recSortCode,
				applyDate: this.applyDate,
				// 图片list
				list: this.addPhotoList,
				testConclusion: this.conclusionId,
				testConclusion2: this.conclusionId2,
				testConclusion3: this.conclusionId3,
				testDate: this.date,
				testMan: this.userName,
				testTimes: 1,
				// 参考文件/标准
				testReferences: "",
				// 范畴。质量：1 ； 安全：2； 进度：3
				category: 2,
				partsName: this.parts,
				// 重要程度
				iptFlg: this.importantId,
				testId: "",
				testType: this.checkTypeId,
				// 检验内容
				probContext: this.content,
				// 整改意见（PC端实际上传的画面中项目【检验意见】的值）
				sutContent: this.sutContent,
				// 备注
				remark: this.remark,
				scenePhotoList: this.addScenePhotoList,
				closeFileList: this.addCloseFileList,
				closePhotoList: this.addClosePhotoList,
				closeTime: this.closeTime,
				closeMan: this.closeMan

			}
			saveTestRecord(param).then(response => {
				if (response.data.resultCode === 200) {
					Notify({ type: 'success', message: '操作成功' });
					this.goBack()
				} else {
					Notify({ type: 'danger', message: response.data.resultMessage });
				}
			})
		},
	}
}
</script>
<style lang="scss" src="@/assets/sass/common.scss"></style>